// export const API_URL = "http://localhost:8000";
//helper for localhost detection:
let url = window.location.href;
let localhost = false;
if (url.includes('localhost')) {
    localhost = true;
}
export const PRODUCTION = !localhost;
//export const ASSET_URL = PRODUCTION ? 'https://stopline.bee-secure.lu/wp-content/themes/salient-child/includes/stopline/report-form' : '';
//export const ASSET_URL = PRODUCTION ? 'https://stopline.modesk.io/wp-content/themes/salient-child/includes/stopline/report-form' : '';
export const ASSET_URL = PRODUCTION ? 'https://stopline.snj-dev.lu/wp-content/themes/salient-child/includes/stopline/report-form' : '';
